import { createContext, useContext } from "react";

/**
 * Whether the counterparty or broker currently being viewed is a merger. Provided by the two
 * detail pages next to EntityVpProvider, so the route guards, attachment lists and sign-off page
 * deep inside them can widen access for ComplianceLegal (see canManageEntity) without every
 * component being handed the entity.
 *
 * Defaults to false, so any consumer rendered outside a provider behaves exactly as before.
 */
const EntityMergerContext = createContext(false);

export const EntityMergerProvider = EntityMergerContext.Provider;

export const useIsEntityMerger = () => useContext(EntityMergerContext);
